<template>
  <div id="publicChatList">
    <div>
      <el-input placeholder="根据主题搜索" v-model="chatSearch" class="input-with-select" prefix-icon="el-icon-search">
      </el-input>
      <el-button icon="el-icon-thumb" @click="optionDialog" class="askBtn">发布意见及建议</el-button>
    </div>
    <el-table :data="interactive_information.data" default-expand-all>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="table-expand">
            <el-form-item :label="props.row.answerText?'回复':'暂无回复'">
              <span>{{ props.row.answerText }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="askingText" label="主题">
      </el-table-column>
      <el-table-column prop="nickname" width="160" label="用户名">
      </el-table-column>
      <el-table-column prop="createTime" label="时间" width="160">
      </el-table-column>
    </el-table>
    <el-pagination @current-change="handleTableCurrentChange" :current-page="tableAttr.currentPage"
                   :page-size="tableAttr.pageSize" layout="total, prev, pager, next, jumper" :total="tableAttr.total">
    </el-pagination>

    <el-dialog
        title="您的意见及建议"
        :visible.sync="show"
        width="30%">
      <el-form style="margin-left: 10px;margin-right: 10px;" label-width="200">
        <el-form-item label="您的意见及建议" label-position="top">
          <el-input v-model="askQuestion" ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show = false">取 消</el-button>
        <el-button type="primary" @click="handleConfirmBtnClick()">确 定</el-button>
      </span>
    </el-dialog>


  </div>
</template>

<script>
import API from "../../../../config/api";

export default {
  data() {
    return {
      interactive_information: {
        data: [], //[{commentId,askingText,answerText},...]
      },
      chatSearch: '',
      tableAttr: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      askQuestion: '',
      show: false,
    }
  },
  async mounted() {
    /**
     * 获取互动信息*/
    await this.getCommentList();
  },
  watch: {
    chatSearch: function () { //实时可以搜索
      this.tableAttr.currentPage = 1;
      this.getCommentList();
    }
  },
  methods: {
    handleTableCurrentChange(val) {
      this.tableAttr.currentPage = val;
      this.getCommentList();
    },
    /**
     * 发布建议*/
    optionDialog() {
      this.show = true;
    },
    handleConfirmBtnClick() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        comment: this.askQuestion,
      }
      this.$axiosRequest({
        url: API.addPublicComment,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({type: 'success', message: '发布成功'});
            this.interactive_information.data.push({
              askingText: this.askQuestion
            })
            this.tableAttr.total++;
            this.$forceUpdate();
            this.show = false

          } else if (res.data == -2) {
            this.$message({type: 'warning', message: '参数错误'});
            this.show = false
            return
          } else if (res.data == -1) {
            this.$message({type: 'warning', message: '程序出错'});
            this.show = false
          }

        }
      });

      this.getCommentList()
    },
    getCommentList: async function () {
      let self = this;

      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      let data = {
        pageNum: self.tableAttr.currentPage,
        pageSize: self.tableAttr.pageSize,
        chatSearch: self.chatSearch
      }
      this.$axiosRequest({
        url: API.getPublicCommentList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          for (let i = res.data.commentList.length - 1; i >= 0; i--) {
            if (!res.data.commentList[i].answerText) {
              res.data.commentList[i].answerText = "";
            }
          }
          self.interactive_information.data = res.data.commentList;
          self.tableAttr.total = res.data.commentList.length;

        }
      });

    },
  }
}
</script>

<style lang="less">
#publicChatList {
  .subtitle {
    margin-bottom: 10px;
  }

  .dialog {
    margin: 5px 0;
    padding: 5px 0;
    background: #eeeeee;
    font-size: 14px;
  }

  .askingText,
  .answerText {
    margin: 5px 0;
    height: 20px;
  }

  .table-expand label {
    margin-left: 55px;
    color: #99a9bf;
  }

  .el-table .cell {
    font-size: 14px !important;
  }

  .input-with-select {
    width: 60%;
  }

  .askBtn {
    float: right;
  }
}
</style>
